export type PlayerButtonColor = "blue" | "gray" | "white"

/** @deprecated Prefer PlayerButtonColor — same union. */
export type PlayerVolumeColor = PlayerButtonColor

const LIGHT_ICON_DIR = "/icons/player/thick"
/** Black icons for white buttons (SegmentPage / instuderen). */
const BLACK_ICON_DIR = "/icons/player/thick/black"
/** Lilac (#212037) icons for gray buttons (AudioPlayer). */
const LILAC_ICON_DIR = "/icons/player/thick/dark"

export function getPlayerIconDirectory(color: PlayerButtonColor) {
  if (color === "blue") return LIGHT_ICON_DIR
  if (color === "white") return BLACK_ICON_DIR
  return LILAC_ICON_DIR
}

export function usesDarkPlayerIcons(color: PlayerButtonColor) {
  return color !== "blue"
}

/** Resolve a thick player icon path for the given button color. */
export function getPlayerThickIcon(color: PlayerButtonColor, fileName: string) {
  return `${getPlayerIconDirectory(color)}/${fileName}`
}
